export const theme = {
    colors: {
        white: 'hsl(0, 0%, 100%)',
        whiteAlpha50: 'hsla(0, 0%, 100%, 0.5)',
        whiteAlpha75: 'hsla(0, 0%, 100%, 0.75)',
        black: 'hsl(240, 67%, 8%)',
        grayDark: 'hsl(240, 17%, 26%)',
        grayLight: 'hsl(240, 6%, 54%)',
        turquoise: 'hsl(194, 48%, 49%)',
        orangeLight: 'hsl(33, 82%, 61%)',
        orangeDark: 'hsl(10, 63%, 51%)',
        purple: 'hsl(263, 67%, 51%)',
        redLight: 'hsl(2, 68%, 53%)',
        redDark: 'hsl(17, 73%, 46%)',
        green: 'hsl(169, 73%, 44%)',
        blue: 'hsl(222, 87%, 56%)',
    },
    fonts: {
        primary: `'Spartan', sans-serif`,
        secondary: `'Antonio', sans-serif`,
    },
};
